import { render, staticRenderFns } from "./LogisticsDetail.vue?vue&type=template&id=2da41256&scoped=true"
import script from "./LogisticsDetail.vue?vue&type=script&lang=js"
export * from "./LogisticsDetail.vue?vue&type=script&lang=js"
import style0 from "./LogisticsDetail.vue?vue&type=style&index=0&id=2da41256&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da41256",
  null
  
)

export default component.exports